<template>
    <nav id="social">
        <div class="d-flex">
            <div class="mx-1 mx-md-0 ml-md-2" v-for="(social, index) in socials" :key="index">
                <a :href="social.url" target="_blank">
                    <fa-icon :icon="[ social.icon_library, social.icon ]" size="lg" alt="social.name" />
                </a>
            </div>
        </div>
    </nav>
</template>

<script>
import Axios from 'axios'

export default {
    name: 'Social',

    data() {
        return {
            socials: []
        }
    },

    created() {
        Axios.get(`${this.$VUE_APP_API_URL}/socials`).then(res =>{
            this.socials = res.data.filter(s => s.active).sort((a, b) => {
                return a.order - b.order
            })
        })
    }
}
</script>